import { render, staticRenderFns } from "./ApiScansPage.vue?vue&type=template&id=2df21815"
import script from "./ApiScansPage.vue?vue&type=script&lang=js"
export * from "./ApiScansPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports